import { Icon } from "../../icons";
import { useTheme } from "../../theme";
import { useTooltip } from "../Tooltip/Tooltip";

export function ThemeToggle(): React.JSX.Element {
  const { theme, toggleTheme } = useTheme();
  const label = theme === "dark" ? "Switch to light theme" : "Switch to dark theme";
  const { anchorProps, tooltip } = useTooltip(label);
  return (
    <>
      <button
        type="button"
        className="nb-icon-btn nb-theme-btn"
        data-theme={theme}
        aria-label={label}
        onClick={() => toggleTheme()}
        {...anchorProps}
      >
        <span className="nb-theme-icons" aria-hidden="true">
          <Icon name="moon" className="nb-theme-moon" />
          <Icon name="sun" className="nb-theme-sun" />
        </span>
      </button>
      {tooltip}
    </>
  );
}
